import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngstack/translate';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { CIDService } from 'src/app/services/common/cid.service';
import { BIDService } from 'src/app/services/common/bid.service';
import { HoldingService } from 'src/app/services/http/business/holding/holding.service';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { BranchService } from 'src/app/services/http/business/branch/branch.service';
import { ICompany } from 'src/app/interfaces/company';
import { IBranch } from 'src/app/interfaces/branch';
import { MatSelectChange, MatSelect } from '@angular/material';
//import { RegistrationReportService } from 'src/app/services/http/business/report/registration-report.service';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { ITermInfo } from 'src/app/interfaces/term-info';
import { TermInfoService } from 'src/app/services/http/business/term-info/term-info.service';
import { ILevelInfo } from 'src/app/interfaces/levelInfo';
import { IEducationPackage } from 'src/app/interfaces/educationPackage';
import { EducationPackageService } from 'src/app/services/http/business/educationPackage/education-package.service';
import { LevelInfoService } from 'src/app/services/http/business/levelInfo/level-info.service';
import * as moment from "jalali-moment";
import { CoursePatternService } from 'src/app/services/http/business/course-pattern/course-pattern.service';
import { ServiceRoute } from 'src/app/services/http/base/service-route';
import { JwtHelperService } from '@auth0/angular-jwt';
import { IParentTerm } from 'src/app/interfaces/parent-term';
import { ParrentTermService } from 'src/app/services/http/business/parrent-term/parrent-term-service.service';
import { CalendarService } from 'src/app/services/http/business/calendar/calendar.service';
import { ICalendar } from 'src/app/interfaces/calendar';
import { CourseTypeService } from 'src/app/services/http/business/course-type/course-type.service';
import { ICourseType } from 'src/app/interfaces/course-type';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-edu-org-report',
  templateUrl: './edu-org-report.component.html',
  styleUrls: ['./edu-org-report.component.css']
})
export class EduOrgReportComponent implements OnInit {

  param: any;
  errObject: any;
  errors = new Array();
  form: FormGroup;
  isOwner: boolean;
  compnayList: ICompany;
  branchList: IBranch[];
  reportUrl: string;
  iframe: any;
  termList: ITermInfo[];
  termList2: ITermInfo[];
  TermInfo: number;
  startDateModel: string;
  endDateModel: string;
  levelInfoList: ILevelInfo[];
  yearList: ICalendar;
  parrentTermList: any; //IParentTerm[];
  parrentTermList2: IParentTerm[];
  coursPatterns: any;
  userName: string;
  eduPackageList: IEducationPackage;
  emptyListUrl: string;
  token = localStorage.getItem("token");
  reports = [
    { id: 1, title: 'دفتر آموزش و پرورش ', active: true },
    { id: 2, title: 'لیست کلاسی بر اساس الگو ', active: true }
  ];


  courseTypeList: ICourseType;

  showPackage = false;
  showLevel = false;
  showPattern = false;
  showTerm = false;
  showTerm2 = false;
  showTime = false;
  showYear = false;
  showYear2 = false;
  showNationalCode = false;
  showName = false;
  showTermInfo = false;
  showTermInfo2 = false;
  showEmptyBtn = false;

  constructor(
    private fb: FormBuilder,
    private cidService: CIDService,
    private bidService: BIDService,
    private holdingService: HoldingService,
    private calendarService: CalendarService,
    private companyService: CompanyService,
    private branchService: BranchService,
    public translate: TranslateService,
    private parrentTermService: ParrentTermService,
    private errorService: ErrorsService,
    private courseTypeService: CourseTypeService,
    private coursPatternService: CoursePatternService,
    private termService: TermInfoService,
    private sanitizer: DomSanitizer,
    private eduPackageService: EducationPackageService,
    private levelInfoService: LevelInfoService
  ) { }

  ngOnInit() {
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(this.token);
    this.userName = decodedToken.fname;
    this.checkOwner();
    this.createForm();
    this.getCompanyList();
    this.getEduPackage();
    this.loadYear();
  }

  createForm() {
    this.form = this.fb.group({
      BranchEncryptId: [null],
      ReportId: [null, Validators.required],
      ParentTermId: [null],
      ParentTermId2: [null],
      StartDate: [null],
      EndDate: [null],
      PackageId: [null],
      Year: [null],
      Year2: [null],
      TermInfoId: [null],
      TermInfoId2: [null],
      LevelInfoId: [null],
      CourseTypeId: [null],
      CoursePatternId: [null],
      RegistrationStatusId: [null],
      NationalCode: [null],
      FirstName: [null],
      LastName: [null]
    });
    if (this.isOwner) {
      this.form.setValue({
        BranchEncryptId: this.bidService.getBID()
      });
    }
  }

  loadYear() {
    this.calendarService.yearList().subscribe(
      res => {
        this.yearList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadCoursTypeList() {
    this.courseTypeService.list(0, 0, false, false, true).subscribe(
      res => {
        this.courseTypeList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  // loadCoursePattern(e: MatSelect) {
  //   this.hideTerms = true;
  //   this.hideScheduleTime = true;
  //   this.coursePatternService.getListByCourseTypeId(e.value, 0, 0).subscribe(
  //     res => {
  //       this.coursePatternList = res;
  //     },
  //     () => {
  //       this.errorService.transactionError();
  //     }
  //   );
  // }

  getCoursPattern(e: MatSelect) {
    this.coursPatternService.getListByCourseTypeId(e.value, 0, 0).subscribe(res => {
      this.coursPatterns = res;
    },
      () => {
        this.errorService.transactionError();
      });
  }
  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
        this.bidService.setBID("");
      }
      else {
        this.loadCoursTypeList();
        //this.getParrentTermList();
        // this.termService.list(0, 0).subscribe(res => {
        //   this.termList = res.DataList;
        // });
      }
    });
  }

  getParrentTermList(e: MatSelect) {
    this.parrentTermService.listComboByYear(e.value).subscribe(
      res => {
        this.parrentTermList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getParrentTermList2(e: MatSelect) {
    this.parrentTermService.listComboByYear(e.value).subscribe(
      res => {
        this.parrentTermList2 = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getEduPackage() {
    this.eduPackageService.getList().subscribe(
      res => {
        this.eduPackageList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  laodLevel(element: MatSelectChange) {
    this.levelInfoService.getlistByEducationPackageId(element.value).subscribe(
      res => {
        this.levelInfoList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  setReport(e: MatSelectChange) {

    for (const key in this.form.controls) {
      if(key != 'ReportId')
      {
        this.form.get(key).clearValidators();
        this.form.get(key).updateValueAndValidity();
        this.form.get(key).reset();
      }
    }

    if(this.isOwner)
    {
      this.changeValidators('BranchEncryptId');
    }

    this.showPackage = false;
    this.showLevel = false;
    this.showPattern = false;
    this.showTerm = false;
    this.showTerm2 = false;
    this.showTime = false;
    this.showYear = false;
    this.showYear2 = false;
    this.showNationalCode = false;
    this.showName = false;
    this.showTermInfo = false;
    this.showTermInfo2 = false;
    this.showEmptyBtn = false;
    switch (parseInt(e.value)) {
      case 1:

        this.changeValidators('Year');
        this.changeValidators('ParentTermId');

        this.showTerm = true;
        this.showYear = true;
        break;
      case 2:

        this.changeValidators('Year');
        this.changeValidators('ParentTermId');
        this.changeValidators('CourseTypeId');
        this.changeValidators('CoursePatternId');

        this.showTerm = true;
        this.showYear = true;
        this.showPattern = true;
        this.showTermInfo = true;
        this.showEmptyBtn = true;
        break;

    }
  }

  changeValidators(key: string) {
    this.form.controls[key].setValidators(Validators.required);
    this.form.controls[key].updateValueAndValidity();
  }

  setCid(e: MatSelectChange) {
    if (this.isOwner) {
      this.cidService.setCID(e.value);
      this.bidService.removeBID();
      this.loadCoursTypeList();
    }
    this.getBranchList(e.value);
    //this.getParrentTermList();

  }

  setBid(e: MatSelect) {
    if (this.isOwner)
      this.bidService.setBID(e.value);

  }
  setDate(e: MatSelect) {
    const parentTerm = this.parrentTermList.find(function (element) {
      return element.Id == e.value;
    });

    this.startDateModel = parentTerm.StartDate; //moment.from(year + '/' + parentTerm.MonthAndDayStart, 'fa', 'YYYY/MM/DD').format('YYYY/MM/DD')
    this.endDateModel = parentTerm.EndDate; //moment.from(year + '/' + parentTerm.MonthAndDayEnd, 'fa', 'YYYY/MM/DD').format('YYYY/MM/DD')
    this.termService.getListById(e.value, 0, 0).subscribe(res => {
      this.termList = res.DataList;
    });
  }
  setDate2(e: MatSelect) {

    this.termService.getListById(e.value, 0, 0).subscribe(res => {
      this.termList2 = res.DataList;
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.compnayList = res.DataList;
    });
  }

  getBranchList(company) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );
    this.branchService.listByCompanyHeader(0, 0, headers).subscribe(
      res => {
        this.branchList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }
  getEmptyListUrl(data: any) {
    return environment.ReportBaseUrl + ServiceRoute.report.education.GetCorseByEmptyShow +
      '?CompanyId=' + this.cidService.getCID() +
      '&UserName=' + this.userName +
      '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
  }
  submit(data: any) {
    data.StartDate = moment
      .from(data.StartDate, "en")
      .utc(true)
      .format(environment.dateFormat);

    data.EndDate = moment
      .from(data.EndDate, "en")
      .utc(true)
      .format(environment.dateFormat);
    let url = '';
    switch (parseInt(data.ReportId)) {
      case 1:
        url = environment.ReportBaseUrl + ServiceRoute.report.eduOrg.GetEduOrgStudentShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&ParentTermId=' + data.ParentTermId +
          '&UserName=' + this.userName +
          '&Year=' + data.Year +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
      case 2:
        url = environment.ReportBaseUrl + ServiceRoute.report.eduOrg.GetCorseByPatternShow +
          '?CompanyId=' + this.cidService.getCID() +
          '&ParentTermId=' + data.ParentTermId +
          '&TermInfoId=' + data.TermInfoId +
          '&UserName=' + this.userName +
          '&Year=' + data.Year +
          '&CoursePatternId=' + data.CoursePatternId +
          '&BranchId=' + ((this.isOwner) ? (data.BranchEncryptId && data.BranchEncryptId != '0' ? data.BranchEncryptId : null) : this.bidService.getBID());
        break;
    }
    this.iframe = this.sanitizer.bypassSecurityTrustResourceUrl(url.split("null").join(""));
  }
}

